
import PersonalDataComponent from "@/components/RegisterTest/PersonalData/PersonalDataComponent";
export default PersonalDataComponent;
